export const BULK_ASSIGN_ALERT_TYPES_OPEN_MODAL = "BULK_ASSIGN_ALERT_TYPES_OPEN_MODAL";
export const BULK_ASSIGN_ALERT_TYPES_REQUEST = "BULK_ASSIGN_ALERT_TYPES_REQUEST";
export const BULK_ASSIGN_ALERT_TYPES_RESULT = "BULK_ASSIGN_ALERT_TYPES_RESULT";